import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
// import Typography from '@mui/material/Typography';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderSelect, renderTextField} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.ITAKU_TSTK_GUTISU_LIST.name, href: ''},
];

// 調査・点検対象集計の場合、パンくずリストの表示内容
const transitionListSk = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.ITAKU_TSTK_GUTISU_SK_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const planViews = [
  {binding: 'nwJigyosyo', header: '旧NW事業所', dataType: 'String', width: 90, readOnly: true},
  {binding: 'itakuArea', header: '委託エリア', dataType: 'String', width: 110, readOnly: true},
  {binding: 'tyousakikan', header: '調査機関', dataType: 'String', width: 95, readOnly: true},
  {binding: 'blockNo', header: 'ブロック番号', dataType: 'String', width: 95, readOnly: true},
  {binding: 'daihyoZyusyo', header: '代表住所', dataType: 'String', width: 200, readOnly: true},
  {header: '調査', dataType: 'header', elems: [
    {binding: 'tsGutisu', header: '調査口数', dataType: 'Number', width: 90, readOnly: true},
    {header: '4年に1回調査', dataType: 'header', elems: [
      {binding: 'tsTeigakuOther4', header: '定額以外', dataType: 'Number', width: 90, readOnly: false},
      {binding: 'tsTeigaku4', header: '定額', dataType: 'Number', width: 90, readOnly: false},
    ]},
    {header: '毎年調査', dataType: 'header', elems: [
      {binding: 'tsTeigakuOther1', header: '定額以外', dataType: 'Number', width: 90, readOnly: false},
    ]},
  ]},
  {header: '点検', dataType: 'header', elems: [
    {binding: 'tkGutisu', header: '点検口数', dataType: 'Number', width: 90, readOnly: true},
    {binding: 'tkDotyo', header: '同調', dataType: 'Number', width: 90, readOnly: true},
    {binding: 'tkTandoku', header: '単独', dataType: 'Number', width: 90, readOnly: true},
    {header: ' ', dataType: 'header', elems: [
      {binding: 'dummy', header: '', dataType: 'Number', width: 90, readOnly: true, visible: false},
    ]},

  ]},
  {binding: 'tsTkgoukei', header: '合計', dataType: 'Number', width: 90, readOnly: true},
];

const exceptFiltersBindings = [
  'tsGutisu', 'tkGutisu', 'tsTkgoukei', 'tkDotyo', 'tkTandoku',
];

// 調査・点検口数(予定)一覧
const totalViews = [
  {binding: 'goukei', header: '合計（件）', type: 'text', width: 590, readOnly: false},
  {binding: 'tsGutisuGK', header: '調査口数', dataType: 'Number', width: 90, readOnly: true},
  {binding: 'tsTeigakuOther4GK', header: '定額以外', dataType: 'Number', width: 90, readOnly: false},
  {binding: 'tsTeigaku4GK', header: '定額', dataType: 'Number', width: 90, readOnly: false},
  {binding: 'tsTeigakuOther1GK', header: '定額以外', dataType: 'Number', width: 90, readOnly: false},
  {binding: 'tkGutisuGK', header: '点検口数', dataType: 'Number', width: 90, readOnly: true},
  {binding: 'tkDotyoGK', header: '同調', dataType: 'Number', width: 90, readOnly: true},
  {binding: 'tkTandokuGK', header: '単独', dataType: 'Number', width: 90, readOnly: true},
  {binding: 'tsTkgoukeiGK', header: '合計', dataType: 'Number', width: 90, readOnly: true},
];

/**
 * 調査・点検口数(予定)一覧画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    const title = props.title;
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
      title: title,
    };

    this.gridRef = React.createRef();
    this.gridTotalRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10001', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10002', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10003', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10004', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10005', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10006', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10007', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10008', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10009', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10010', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10011', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10012', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10013', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10014', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10015', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10016', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},
      {nwJigyosyo: '福山', itakuArea: '委託２', tyousakikan: '工業組合', blockNo: '10017', daihyoZyusyo: '住所XXXX番地XXX丁目', tsGutisu: '3,000', tsTeigakuOther4: '1,000', tsTeigaku4: '1,000', tsTeigakuOther1: '1,000', tkGutisu: '2,000', tkDotyo: '1,000', tkTandoku: '1,000', tsTkgoukei: '5,000'},


    ];
    const totalData=[
      {goukei: '合計（件）：', tsGutisuGK: '9,999,999', tsTeigakuOther4GK: '9,999,999', tsTeigaku4GK: '9,999,999', tsTeigakuOther1GK: '9,999,999', tkGutisuGK: '9,999,999', tkDotyoGK: '9,999,999', tkTandokuGK: '9,999,999', tsTkgoukeiGK: '9,999,999'},
    ];


    this.gridRef.current.setItemsSource(data);
    this.gridTotalRef.current.setItemsSource(totalData);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    this.gridTotalRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      visible={view.visible}
      // cssClass='bf-gray-background'
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
        data.hiKetuFlag === '1') )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  /**
   * 合計一覧描画
   * @return {*}
   */
  renderTotalTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCE1002HenkomaeTable',
      filterOn: true,
      headersVisibility: 'None',
      allowDragging: 'Columns',
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: false,
      screenId: 'SCE1002Henkomae',
      checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      // DeleteOn: true,
      getError: this.getError,

    };
    // 一覧定義取得
    let viewElems = [];
    if (totalViews) {
      for (const view of totalViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      // <CustomFlexGrid frozenRows={1} ref={this.gridRef} {...props}>
      <CustomFlexGrid ref={this.gridTotalRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['帳票出力'],
      },
    });
  };

  /**
 * CSV出力クリック時
 */
  CSVoutput = async () => {
    try {

    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      exceptFilters: exceptFiltersBindings,
      style: {maxHeight: '380px', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
    };

    let viewElems = [];
    if (planViews) {
      for (const view of planViews) {
        const header = view.header;
        if (!header) {
          continue;
        }
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            let secondViewElem;
            let thirdViewGElem;
            // 2層ヘッダー処理
            if (elem.dataType === 'header') {
              let secondViewGroups = [];
              for (const secondElem of elem.elems) {
                if (secondElem.dataType === 'header') {
                  let thirdViewGroups = [];
                  for (const thirdElem of secondElem.elems) {
                    thirdViewGroups.push(this.getViewElem(thirdElem));
                  }
                  thirdViewGElem =
                    <FlexGridColumnGroup header={secondElem.header}>
                      {thirdViewGroups}
                    </FlexGridColumnGroup>;
                  secondViewGroups.push(thirdViewGElem);
                } else {
                  secondViewGroups.push(this.getViewElem(secondElem));
                }
              }
              secondViewElem = <FlexGridColumnGroup header={elem.header}>
                {secondViewGroups}
              </FlexGridColumnGroup>;
              viewGroups.push(secondViewElem);
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'山口'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="旧NW事業所"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>

          <Grid key="itakuArea" item xs={12} sm={2}>
            <Field
              id="itakuArea"
              name="itakuArea"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="委託エリア"
              type="text"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={0}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'0000'}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        ><Grid key="blockNo" item xs={12} sm={4}>
            <Field
              id="blockNoFrom"
              name="blockNoFrom"
              label="ブロック番号"
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
            <span className="wave">～</span>
            <Field
              id="blockNoTo"
              name="blockNoTo"
              label={<React.Fragment />}
              component={renderTextField}
              className="fields"
              type="text"
              sx={{width: '40%'}}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>
          <Grid key="tdhknAddCd" item xs={12} sm={6}>
            <Field
              id="tdhknAddCd"
              name="tdhknAddCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="都道府県"
              type="text"
              sx={{width: '20%'}}
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={31}>{'鳥取県'}</MenuItem>
              <MenuItem value={32}>{'島根県'}</MenuItem>
              <MenuItem value={33}>{'岡山県'}</MenuItem>
              <MenuItem value={34}>{'広島県'}</MenuItem>
              <MenuItem value={35}>{'山口県'}</MenuItem>
            </Field>

            <Field
              id="azatmApart"
              name="azatmApart"
              // variant="standard"
              component={renderTextField}
              // className="fields"
              label="住所"
              sx={{width: '75%'}}
              type="text"
              required={false}
              InputProps={{
                readOnly: false,
              }}
            />
          </Grid>

        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.state.title !== transitionListSk[1].gmnName &&
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
          >
            <span>調査・点検口数(予定)一覧表</span>
          </PositiveButton>
        </Grid>
        }
        {this.state.title !== transitionListSk[1].gmnName &&
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
          >
            <span>調査・点検口数(予定)一覧表(保安協会)</span>
          </PositiveButton>
        </Grid>
        }
        {this.state.title === transitionListSk[1].gmnName &&
        <Grid key="CSVoutput" item>
          <PositiveButton
            id="CSVoutput"
            onClick={handleSubmit(this.CSVoutput)}
            variant="contained"
            startIcon={<GetAppIcon/>}
          >
            <span>CSV出力</span>
          </PositiveButton>
        </Grid>
        }
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={ this.state.title === transitionListSk[1].gmnName ? transitionListSk : transitionList} />
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className='button_list'
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-end"
          >

            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              direction={'row'}
            >
              {this.renderTable()}
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
              direction={'row'}
            >
              {this.renderTotalTable()}
            </Grid>

          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      zigyoujo: '5160',
      zigyoujoOld: '5160',
      tyousakikan: '0000',
      itakuArea: '0',
      // tyousakikan: '保安協会',
    },
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

